module.exports = __webpack_public_path__ + "static/media/safari-pinned-tab.d33588c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/boostabostad-favicon/safari-pinned-tab.svg
// module id = 392
// module chunks = 0